module.exports = __webpack_public_path__ + "img/bubbles1.3c57343c.png";